import { Autocomplete, TextField } from "@mui/material";

const SearchableDropdownV1 = ({
  itemList = [],
  value,
  onChange,
  placeholder = "Select",
}) => {
  return (
    <Autocomplete
      options={itemList}
      value={value || null}
      onChange={(_, newValue) => onChange?.(newValue || "")}
      getOptionLabel={(option) => option ?? ""}
      isOptionEqualToValue={(opt, val) => opt === val}
      renderInput={(params) => (
        <TextField {...params} placeholder={placeholder} size="small" />
      )}
      clearOnEscape
    />
  );
};

export default SearchableDropdownV1;
